import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MaterialModule } from 'src/app/core/material.module';

import { AbilityService } from 'src/app/core/services/ability/ability.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ALL_TEST_ROOM_STATUS_OPTIONS } from 'src/app/features/tests/features/constants';
import { CustomTextService } from '../../services/custom-text.service';
import { trackFeatureUse } from 'src/app/core/analytics';

@Component({
  selector: 'app-add-default-texts-dialog',
  templateUrl: 'add-default-texts-dialog.component.html',
  styleUrls: ['add-default-texts-dialog.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
})
export class AddCustomTextDialogComponent implements OnInit {
  form: FormGroup;
  public isLoading: boolean;
  constructor(
     public ability: AbilityService,
    private notificationService: NotificationService,
    public customTextService: CustomTextService,
    public dialogRef: MatDialogRef<AddCustomTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {name: string, label: string, maxLength?: number, initialValue: string},
  ) {}

  allTestRoomStatusOptions = ALL_TEST_ROOM_STATUS_OPTIONS;

  get hasError() {
    return this.form?.value?.value?.length  > this.data.maxLength
  }
  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl('', []),
      label: new FormControl('', []),
      value: new FormControl(this.data.initialValue || '', this.data.maxLength ? [Validators.required, Validators.maxLength(this.data.maxLength), (control) =>
            (control.value || '').trim().length === 0
              ? { whitespace: true }
              : null,] : [Validators.required, (control) =>
            (control.value || '').trim().length === 0
              ? { whitespace: true }
              : null,]),
      departmentId: new FormControl(undefined),
    });

    this.form.patchValue({
        name: this.data.name,
    });

    if (!this.ability.isDepartmentVisible) {
      this.form.patchValue({
        departmentId: this.ability.departmentId,
      });
    }
  }

  onClose() {
    this.dialogRef.close(null);
  }

  save() {
    trackFeatureUse('custom_texts', 'saved');
    if(this.isLoading){return}

    if (this.form.invalid) {
      this.isLoading = false;
      return;
    }

    const payload = this.form.value;
    payload.value =   payload.value?.trim()
    this.isLoading = true;
    this.customTextService.updateCustomTexts(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.dialogRef.close(res);
        this.notificationService.success(`Created Successfully ${this.data.label}`);
      },
      error: (err) => {
        if(err.error.message == 'REPORT_CONFIG.ERRORS.DUPLICATE') {
           this.form.get('value')?.setErrors({ duplicate: true });
        }else{
                 this.notificationService.error(`Error creating ${this.data.label}`);
        }

        this.isLoading = false;
      },
    });
  }

}
